// Awards & Completions Step 2 (Configure Parameters). Display and validation only: nothing
// here pulls data, it just shapes the parameters a later story will post.
import { getReportingScopeErrors } from './reportingScope';

export const AWARDS_INITIAL_PARAMETERS = {
    reportingYear: '',
    outputFormat: '',
    cipCodeYear: '',
    reportingPeriodStart: null,
    reportingPeriodEnd: null,
    // Empty means "All". The filter narrows; it never needs to be empty-and-invalid.
    awardLevelCodes: []
};

/** The newest CIP edition the reference tables offer, which is what a new extract should use. */
export const newestCipCodeYear = (cipCodeYears) => (cipCodeYears || [])
    .reduce((newest, year) => (year.uniqueId > newest ? year.uniqueId : newest), '');

export const awardsInitialParameters = (selectItems) => ({
    ...AWARDS_INITIAL_PARAMETERS,
    cipCodeYear: newestCipCodeYear(selectItems?.cipCodeYears)
});

// The Earned Degrees labels run to a full sentence for the clock-hour levels, which is why the
// design uses checkboxes with short labels. Levels 1a/1b/2/4 are shown as the bare code, with
// the full federal text as the tooltip; a code missing here falls back to that full text.
const AWARD_LEVEL_SHORT_LABEL_KEYS = {
    3: 'ipedsWizard.awardLevelAssociates',
    5: 'ipedsWizard.awardLevelBachelors',
    6: 'ipedsWizard.awardLevelPostbaccCertificate',
    7: 'ipedsWizard.awardLevelMasters',
    8: 'ipedsWizard.awardLevelPostMastersCertificate',
    17: 'ipedsWizard.awardLevelDoctorsResearch',
    18: 'ipedsWizard.awardLevelDoctorsProfessional',
    19: 'ipedsWizard.awardLevelDoctorsOther'
};
const CODE_ONLY_AWARD_LEVELS = ['1a', '1b', '2', '4'];

export const awardLevelLabel = (t, level) => {
    if (CODE_ONLY_AWARD_LEVELS.includes(level.uniqueId)) return level.uniqueId;
    const key = AWARD_LEVEL_SHORT_LABEL_KEYS[level.uniqueId];
    return key ? `${level.uniqueId} — ${t(key, { ns: 'tools' })}` : level.displayText;
};

// Earned Degrees lists the levels in IPEDS publication order (4 before 3); the checkbox grid
// reads by code instead: 1a, 1b, 2, 3, 4 … 19.
export const sortAwardLevels = (levels) => [...(levels || [])].sort((a, b) =>
    (parseInt(a.uniqueId, 10) - parseInt(b.uniqueId, 10)) || String(a.uniqueId).localeCompare(String(b.uniqueId)));

/** Toggling a level narrows the filter; clearing the last one falls back to All. */
export const toggleAwardLevel = (codes, code) => (codes.includes(code)
    ? codes.filter((existing) => existing !== code)
    : [...codes, code]);

/**
 * Field → { key, field } for every rule the parameters break. The CIP edition and award level
 * filter are optional, so only the reporting scope can fail.
 */
export const getAwardsParameterErrors = (parameters) => getReportingScopeErrors(parameters, {
    startLabel: 'ipedsWizard.startDate',
    endLabel: 'ipedsWizard.endDate',
    endBeforeStartKey: 'ipedsWizard.endBeforeStart'
});
